import { StatsBasicStatistics } from './utilities/basics';
import { StatsCurveAnalyzer } from './utilities/curve-analyzer';
import { StatsProbability } from './utilities/probability';
import { StatsRegression } from './utilities/regression';


/**------------------------------------------------------
 * Statistics Utilities
 * --------------------
 * > Extracted Dependencies: regression
 */
export class Stats {

	//** Basic Statistics */
	static readonly Basic			: StatsBasicStatistics 	= new StatsBasicStatistics();

	//** Regression */
	static readonly Regression		: StatsRegression 		= new StatsRegression();

	//** Curve Analyzer */
	static readonly CurveAnalyzer	: StatsCurveAnalyzer 	= new StatsCurveAnalyzer(Stats.Regression);

	//** Probability */
	static readonly Probability		: StatsProbability 		= new StatsProbability();
}
